var rich_content_viewer_default = {
  "fontElementMap": "f-yvx",
  "wrapper": "-SteZ",
  "pluginContainerMobile": "vmjS1",
  "viewer": "DRMfa",
  "android": "_1xjz2",
  "rootedTraversedContent": "mSLaT",
  "atomic": "_9LYNz",
  "toolbar": "jGDx4",
  "block": "_2rqYS"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
